import moment from 'moment';
import UpdateApplicationRequest from '../models/applications/api/UpdateApplicationRequest';
import ApplicationModel from '../models/applications/api/ApplicationModel';
import IResult from '../models/result/IResult';

export const buildLaunchDateUpdate = (date: string, isLive: boolean): UpdateApplicationRequest => {
    if (!date && !isLive) return { clearTargetLaunchDate: true };
    const utcDate = date ? moment.utc(date, 'YYYY-MM-DD').toISOString() : null;
    return isLive
        ? { launchDate: utcDate, shouldUpdateLaunchDate: true }
        : { targetLaunchDate: utcDate, shouldUpdateLaunchDate: true };
};

export const wasLaunchDateUpdateSaved = (
    result: { resultType: string, data?: ApplicationModel },
    date: string,
    isLive: boolean
): boolean => result.resultType === 'Ok'
    && (date !== '' || (isLive ? result.data?.launchDate === null : result.data?.targetLaunchDate === null));

export const confirmLaunchDateUpdate = async (
    result: IResult<ApplicationModel>,
    date: string,
    isLive: boolean,
    reload: () => Promise<IResult<ApplicationModel>>,
    verifyReadBack = false
): Promise<{ saved: boolean, application?: ApplicationModel }> => {
    if (result.resultType !== 'Ok') return { saved: false };
    if (!verifyReadBack && wasLaunchDateUpdateSaved(result, date, isLive)) {
        return { saved: true, application: result.data };
    }

    try {
        const freshResult = await reload();
        const savedDate = isLive ? freshResult.data?.launchDate : freshResult.data?.targetLaunchDate;
        const matchesRequestedDate = date
            ? !!savedDate && moment.utc(savedDate).format('YYYY-MM-DD') === date
            : savedDate == null;
        return freshResult.resultType === 'Ok' && !!freshResult.data && matchesRequestedDate
            ? { saved: true, application: freshResult.data }
            : { saved: false };
    } catch {
        return { saved: false };
    }
};
